import { Box, Breadcrumbs, Typography, Link as MuiLink } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

/**
 * Cabeçalho padrão das telas da conta: breadcrumb (com "Início" navegável)
 * + título, com uma ação opcional à direita (ex.: StatusChip).
 * Antes cada página remontava isso, com "Home" que não navegava.
 *
 * @param {string} title  título da página (ex.: "Meus pedidos")
 * @param {(string|{label:string,to?:string})[]} crumbs
 *        migalhas após "Início". String = texto; objeto com `to` = link.
 * @param {ReactNode} action  elemento opcional à direita do título.
 */
export default function PageHeader({ title, crumbs = [], action }) {
    return (
        <Box sx={{ mb: '2rem' }}>
            <Breadcrumbs separator="›" aria-label="breadcrumb">
                <MuiLink component={RouterLink} to="/" sx={{ color: 'text.secondary' }}>
                    Início
                </MuiLink>
                {crumbs.map((crumb, index) => {
                    const isLink = typeof crumb === 'object' && crumb.to;
                    if (isLink) {
                        return (
                            <MuiLink key={index} component={RouterLink} to={crumb.to} sx={{ color: 'text.secondary' }}>
                                {crumb.label}
                            </MuiLink>
                        );
                    }
                    const label = typeof crumb === 'object' ? crumb.label : crumb;
                    return (
                        <Typography key={index} sx={{ color: 'text.primary' }}>
                            {label}
                        </Typography>
                    );
                })}
            </Breadcrumbs>
            {title && (
                <Box
                    sx={{
                        mt: '1rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 2,
                        flexWrap: 'wrap',
                    }}
                >
                    <Typography variant="h3">{title}</Typography>
                    {action}
                </Box>
            )}
        </Box>
    );
}
